import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ChangePasswordComponent } from './change-password/change-password.component';
import { ConsentEnergyComponent } from './consent-energy/consent-energy.component';
import { consentTokenGuard } from './consent-token.guard';
import { DenyEnergyComponent } from './deny-energy/deny-energy.component';
import { ErrorComponent } from './error/error.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { PresentationLayoutComponent } from './layouts/presentation-layout/presentation-layout.component';
import { SimpleLayoutComponent } from './layouts/simple-layout/simple-layout.component';
import { LoginComponent } from './login/login.component';
import { PublicComponent } from './public.component';
import { SignupComponent } from './signup/signup.component';
import { tokenGuard } from './token.guard';

const routes: Routes = [
  {
    path: '',
    component: PublicComponent,
    children: [
      {
        path: '',
        redirectTo: 'login',
        pathMatch: 'full',
      },
      {
        path: 'login',
        component: PresentationLayoutComponent,
        children: [
          {
            path: '',
            component: LoginComponent,
          },
        ],
      },
      {
        path: 'forgot-password',
        component: PresentationLayoutComponent,
        children: [
          {
            path: '',
            component: ForgotPasswordComponent,
          },
        ],
      },
      {
        path: 'change-password',
        component: PresentationLayoutComponent,
        canActivate: [tokenGuard],
        children: [
          {
            path: '',
            component: ChangePasswordComponent,
          },
        ],
      },
      {
        path: 'signup',
        component: PresentationLayoutComponent,
        canActivate: [tokenGuard],
        children: [
          {
            path: '',
            component: SignupComponent,
          },
        ],
      },
      {
        path: 'consent',
        component: SimpleLayoutComponent,
        canActivate: [consentTokenGuard],
        children: [
          {
            path: '',
            component: ConsentEnergyComponent,
          },
        ],
      },
      {
        path: 'deny',
        component: SimpleLayoutComponent,
        canActivate: [consentTokenGuard],
        children: [
          {
            path: '',
            component: DenyEnergyComponent,
          },
        ],
      },
      {
        path: 'error',
        component: SimpleLayoutComponent,
        children: [
          {
            path: '',
            component: ErrorComponent,
          },
        ],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PublicRoutingModule {}
